import axios from "axios";
import { BASE_URL } from "./baseUrl";
import { getClientSource } from "./Functions";

function authHeaders() {
  const accessToken = localStorage.getItem("accessToken");
  return {
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    company_source: getClientSource(),
  };
}

async function fetchBlob(url) {
  const res = await axios.get(url, {
    responseType: "arraybuffer",
    headers: authHeaders(),
    validateStatus: () => true,
  });

  if (res.status === 401) {
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  if (res.status !== 200) {
    throw new Error("Could not load the document.");
  }

  const contentType =
    res.headers["content-type"] ||
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  return new Blob([res.data], { type: contentType });
}

export async function fetchOffboardingTemplateBlob(documentId) {
  return fetchBlob(`${BASE_URL}/api/offboarding-documents/${documentId}/view`);
}

export async function fetchOffboardingSubmissionBlob(assignmentId) {
  return fetchBlob(
    `${BASE_URL}/api/offboarding-documents/assignments/${assignmentId}/submission/view`
  );
}

export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "document.docx";
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
